import { render, staticRenderFns } from "./WayBill.vue?vue&type=template&id=9ed2ae9e&scoped=true&"
import script from "./WayBill.vue?vue&type=script&lang=js&"
export * from "./WayBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed2ae9e",
  null
  
)

export default component.exports